"use strict";

var _EnvironmentProvider, _OverdriveProvider;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { AuthProvider, createClient, withRequiredAuthentication } from '@autoguru/auth';
import { getToken } from '@autoguru/auth/relay';
import { ContactNumbersProvider, ScrollToTop } from '@autoguru/components';
import { PageLoading } from '@autoguru/components/PageLoader';
import { OverdriveProvider } from '@autoguru/overdrive';
import { AsyncBoundary } from '@autoguru/suspense';
import { EnvironmentProvider, createEnvironment } from '@autoguru/relay';
import { lazy } from 'react';
import { DEPortalHome } from '../pages';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const UserMenu = /*#__PURE__*/lazy(async () => import('@autoguru/components/components/UserMenu/UserMenu'));
const authClient = createClient();
const relayModernEnvironment = createEnvironment({
  fetcherOptions: {
    getToken
  }
});
const AuthRequiredApp = withRequiredAuthentication(() => _EnvironmentProvider || (_EnvironmentProvider = /*#__PURE__*/_jsx(EnvironmentProvider, {
  environment: relayModernEnvironment,
  children: /*#__PURE__*/_jsxs(AsyncBoundary, {
    fallback: PageLoading,
    children: [/*#__PURE__*/_jsx(UserMenu, {}), /*#__PURE__*/_jsx(DEPortalHome, {})]
  })
})), true);
export const App = () => _OverdriveProvider || (_OverdriveProvider = /*#__PURE__*/_jsx(OverdriveProvider, {
  children: /*#__PURE__*/_jsx(AuthProvider, {
    allow_socials: true,
    optionalAuthentication: true,
    client: authClient,
    children: /*#__PURE__*/_jsxs(ContactNumbersProvider, {
      children: [/*#__PURE__*/_jsx(ScrollToTop, {}), /*#__PURE__*/_jsx(AsyncBoundary, {
        fallback: PageLoading,
        children: /*#__PURE__*/_jsx(AuthRequiredApp, {})
      })]
    })
  })
}));